/**
 * @generated SignedSource<<06ed8a4a66993a4073c9eda3c3ee1fd4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_spreadsheetViewResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableGroupByDropdown_GroupByDropdown">;
  readonly " $fragmentType": "topBar_issueNavigator_spreadsheetViewResult";
};
export type topBar_issueNavigator_spreadsheetViewResult$key = {
  readonly " $data"?: topBar_issueNavigator_spreadsheetViewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_spreadsheetViewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_spreadsheetViewResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "ffdd5fb8dffb76e27187167146d67bcf";

export default node;
